import {RootState} from "../store/store";

export const selectReceiveDate = (state: RootState) => state.global.receiveDate;